// Third-party
import {
  mdiViewAgendaOutline,
  mdiViewWeekOutline,
  mdiViewModuleOutline,
  mdiViewDayOutline,
  mdiCalendarRemove,
  mdiPlus,
} from '@mdi/js';
import { Moment } from 'moment';

// Types
import { ElementType } from 'react';
import { TBreak, TLocation, TMember } from '../types';

// Assets
import { ReactComponent as PrinterIcon } from '../static/icons/ic_printer.svg';
import { ReactComponent as FilterIcon } from '../static/icons/ic_filter.svg';

type TViewOption = {
  value: string,
  label:string,
  icon: ElementType,
  isSvg: boolean,
  isMobile: boolean,
  buttonText?: string,
};

const getViewOptions = (isMobile: boolean, isAllowManage: boolean) => {
  const baseOptions = [
    {
      value: 'filter',
      label: 'filters',
      icon: FilterIcon,
      isSvg: true,
      isMobile: true,
    },
    isMobile ? {
      value: 'dayOff',
      label: 'requestTimeoff',
      icon: mdiCalendarRemove,
      buttonText: 'timeoff',
      isSvg: true,
      isMobile: true,
    } : null,
    isAllowManage && isMobile ? {
      value: 'addShift',
      label: 'shift',
      icon: mdiPlus,
      buttonText: 'shift',
      isSvg: true,
      isMobile: true,
    } : null,
  ].filter((x) => !!x);

  if (!isMobile) {
    return [
      {
        value: 'dayGridMonth',
        label: 'month',
        icon: mdiViewModuleOutline,
        isSvg: false,
        isMobile: false,
      },
      {
        value: 'timeGridWeek',
        label: 'week',
        icon: mdiViewWeekOutline,
        isSvg: false,
        isMobile: false,
      },
      {
        value: 'timeGridDay',
        label: 'day',
        icon: mdiViewDayOutline,
        isSvg: false,
        isMobile: false,
      },
      {
        value: 'listWeek',
        label: 'Agenda',
        icon: mdiViewAgendaOutline,
        isSvg: false,
        isMobile: false,
      },
      {
        value: 'print',
        label: 'printSchedule',
        icon: PrinterIcon,
        isSvg: true,
        isMobile: false,
      },
      ...baseOptions,
    ] as Array<TViewOption>;
  }

  return baseOptions as Array<TViewOption>;
};

const SCHEDULE_OPTIONS = [
  { value: 'print', label: 'Print schedule', icon: PrinterIcon },
  { value: 'filter', label: 'Filter', icon: FilterIcon },
];

const CUSTOM_ACTIONS = ['print', 'dayOff', 'addShift'];

export type TInitialScheduleShift = {
  date: null | Moment,
  startTime: null | Moment,
  endTime: null | Moment,
  breakStart: null | Moment,
  breakEnd: null | Moment,
  id?: number | null
  location: TLocation,
  employee: TMember,
  isNew?: boolean,
  breaks: Array<TBreak>
};

const INITIAL_SCHEDULE_SHIFT: TInitialScheduleShift = {
  date: null,
  startTime: null,
  endTime: null,
  isNew: true,
  id: null,
  location: {} as TLocation,
  employee: {} as TMember,
  breaks: [] as Array<TBreak>,
  breakStart: null,
  breakEnd: null,
};

export {
  getViewOptions,
  INITIAL_SCHEDULE_SHIFT,
  SCHEDULE_OPTIONS,
  CUSTOM_ACTIONS,
};
